import { makeStyles, Theme } from "@material-ui/core/styles";

interface IStylesProps {
  backgroundColor: string;
  strokeColor: string;
}

export default makeStyles<Theme, IStylesProps>(() => ({
  box: {
    marginLeft: 4,
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 17,
    width: 17,
    color: ({ strokeColor }) => `#${strokeColor}`,
    backgroundColor: ({ backgroundColor }) => `#${backgroundColor}`,
    border: ({ strokeColor }) => `1px solid #${strokeColor}`
  },
  date: {
    fontSize: 11,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  }
}));
